module.exports = __webpack_public_path__ + "img/NHWBCarousel_parkDrinking.5c2f21d8.jpg";